import React from "react";
import styled from "styled-components";

import Messages from "./messages";

import { Col, Box, Row, Text } from "../../../../comps";
import { Theme } from "../../../../theme/theme-provider";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
`;

const ChatHead = styled(Row)`
  width: 100%;
  /* height: 10%; */
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

const ChatMembers = styled(Row)`
  width: 100%;
  /* height: 10%; */
  padding-left: 1%;
  padding-right: 5%;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
  /* overflow-x: scroll; */
`;

const TextContainer = styled(Box)`
  margin-right: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  background: ${({ background }) => background};
  border-radius: 3px;
`;

const ChatsWrapper = styled(Col)`
  width: 100%;
  height: calc(100% - 75px);
  align-items: center;
  /* border: 1px solid yellow; */
`;

const gradients = [
  `ff0000`,
  `bf137a`,
  `0000ff`,
  `040330`,
  `1c4726`,
  `17323b`,
  `3d2215`,
  `94031e`,
  `003647`,
  `2b2a29`,
];
const Member = ({ username, idx }) => {
  return (
    <TextContainer background={`#${gradients[idx % gradients.length]}`}>
      <Text
        marginLeft="6px"
        marginRight="6px"
        fontSize="14px"
        color="#fff"
        color={Theme.color.GRAY_0}
        style={{ marginTop: "5px", marginBottom: "5px" }}
      >
        {username}
      </Text>
    </TextContainer>
  );
};

export default ({ roomInfo }) => {
  const { members, id } = roomInfo || {};
  return (
    <Wrapper>
      <ChatHead>
        <Text
          marginBottom="2px"
          fontSize="24px"
          fontWeight="600"
          color={Theme.color.GRAY_1}
        >{`ROOM CHAT`}</Text>
        <Text
          fontSize="14px"
          color={Theme.color.GRAY_0}
          marginLeft="20px"
        >{`#${id}`}</Text>
      </ChatHead>
      <ChatMembers>
        {members &&
          members.map((member, idx) => {
            return <Member key={idx} username={member.username} idx={idx} />;
          })}
      </ChatMembers>
      <ChatsWrapper>
        <Messages roomInfo={roomInfo} />
      </ChatsWrapper>
    </Wrapper>
  );
};
